import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    topUp: {
        id: 'modal.topUp.general.button',
        defaultMessage: 'Top up',
    },
    fromWallet: {
        id: 'modal.topUp.general.from_wallet',
        defaultMessage: 'From wallet',
    },
    toCard: {
        id: 'modal.topUp.general.to_card',
        defaultMessage: 'To card',
    },
    amount: {
        id: 'modal.topUp.general.amount_to_card',
        defaultMessage: 'Amount to card',
    },
    zero: {
        id: 'modal.topUp.general.zero',
        defaultMessage: 'Cannot be empty',
    },
    lessFunds: {
        id: 'modal.topUp.general.less',
        defaultMessage: 'Not enough funds.',
    },
    lessFundsFee: {
        id: 'modal.topUp.general.less_fee',
        defaultMessage: 'Not enough funds to cover fees.',
    },
    alert: {
        id: 'modal.topUp.general.alert',
        defaultMessage:
            'Please note that you can only top up your card. Withdrawals are not possible. For all questions, please <a target="_blank" href="{supportLink}">contact support</a>.',
    },
})
